module.exports = __webpack_public_path__ + "img/warning-red.de79e480.svg";